;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import React from 'react';

function ArticleContainer({ children, className, id }: { children: React.ReactNode; className?: string; id?: string }) {
  return (
    <div id={id || ''} className={`articleContainer ${className || ''}`}>
      {children}
    </div>
  );
}

export default ArticleContainer;
